import React from 'react';
export function Footer() {
  return <footer className="bg-dark text-gray-400 py-8 md:py-12 px-4 border-t border-gray-800 text-center" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <div className="font-display text-xl md:text-2xl text-white mb-3 md:mb-4 tracking-wide" data-id="element-157">
          🏟️ MEGAPACK DT FUTSAL™
        </div>
        <p className="text-xs md:text-sm mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-158">
          El sistema de entrenamiento Nº1 para entrenadores de futsal amateur en
          Argentina. Porque armar un equipo que gana no debería costarte
          lesiones, conflictos ni improvisación constante.
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-2 md:gap-4 text-[10px] md:text-xs font-medium mb-6 md:mb-8" data-id="element-159">
          <a href="#" className="hover:text-white transition-colors" data-id="element-160">
            contacto@abastecedordigital.shop
          </a>
          <span className="hidden md:inline" data-id="element-161">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-162">
            @abastecedordigital
          </a>
          <span className="hidden md:inline" data-id="element-163">•</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-164">
            abastecedordigital.shop
          </a>
        </div>

        <p className="text-[10px] md:text-xs text-gray-600" data-id="element-165">
          © abastecedordigital.shop™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}